//
// IMPORTANT: This file is a schema and must be managed with extreme care.
// See types/schema/README.md for more information.
//
import {
  OrderStatusGroup,
  type TradeBlotterColumnId,
} from '@/types/enums/trade-blotter'

export const TRADE_BLOTTER_SCHEMA_VERSION = '1.0'

export interface TradeBlotterConfig {
  columnState: ColumnStateMap
  rowClickBehavior: RowClickBehavior
  quickPreviewLocation: QuickPreviewLocation
  viewType: ViewType
}

export interface ColumnState {
  colId: TradeBlotterColumnId
  displayName: string
  visible: boolean
  width?: number
}

type ColumnStateMap = {
  [OrderStatusGroup.All]: ColumnState[]
  [OrderStatusGroup.Active]: ColumnState[]
  [OrderStatusGroup.Completed]: ColumnState[]
}

export enum RowClickBehavior {
  Preview = 'Preview',
  NewWindow = 'New window',
  // Descoped for v1.0
  // DetailPage = 'Detail page',
}

export enum QuickPreviewLocation {
  Right = 'Right',
}

export enum ViewType {
  Standard = 'Standard',
  Compact = 'Compact',
}
